@use "Styles/includes/variables";
@use "Styles/mixins";

$panelGap: 10px;

:host {
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    line-height: 1;

    .vm-popover__panel {
        position: absolute;
        z-index: mixins.get-z(popover-component, panel);
        box-sizing: border-box;
    }
}

*,
*::before,
*::after {
    box-sizing: inherit;
}

:host([align-horizontal="left"]) .vm-popover__panel {
    left: 0;
}

:host([align-horizontal="right"]) .vm-popover__panel {
    right: 0;
}

:host([align-vertical="bottom"]) .vm-popover__panel {
    top: calc(100% + $panelGap);
}

:host([align-vertical="top"]) .vm-popover__panel {
    bottom: calc(100% + $panelGap);
}
